import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";

import Button from "@mui/material/Button";

import Analytics from './../../analytics';
import UiSelect from "../ui/select";
import {BACKSPLASH_TYPES} from "../kvComponent/core/constants";
import {KVSCENE_BACKSPLASH_TYPES} from "../kvSceneComponent/core/constants";
import {getCurrentLayout} from "../appLayout";
import {
  setActiveFeature,
  toggleSelectionFeatureInfo,
  toggleShowDescriptionCover,
  updateCanvasCount
} from "../../actions/actionFunctions";
import WithClickCount from "../look/hocs/withClickCount";
import {loaderDisable, loaderEnable} from "../ui/loaderView";
import Navigation from "../visComponents/navigation/navigation";
import {setLookActiveFeature} from "../../actions/lookFunctions";
import {featureInterface} from "../../interfaces/featureInterface";

class BacksplashSelect extends Component {

  static propTypes = {
    // activePart: PropTypes.object.isRequired // Backsplash
    updateParent: PropTypes.func,
    useButtons: PropTypes.bool,
    activeFeature: PropTypes.shape(featureInterface),
  };

  handleBacksplashItemClick = async (type, maxClickCountReached) => {
    Analytics.sendClickEvent("backsplash-type-selected-" + type);
    if (maxClickCountReached && maxClickCountReached()) {
      return false
    }
    const backsplashSubPart = this.getBacksplashPart();
    const currentActiveName = backsplashSubPart.activeFeature ? backsplashSubPart.activeFeature.getCountertopGroupsSplittedFeatureName() : "";
    let featureToClick = backsplashSubPart.getFeatureByBacksplashType(type);
    // console.log("featureToClick", featureToClick);
    if (featureToClick && currentActiveName && (featureToClick.getCountertopGroupsSplittedFeatureName() !== currentActiveName)) {
      loaderEnable();
      await Navigation.searchFeaturesByName(backsplashSubPart, currentActiveName);
      loaderDisable();
      featureToClick = backsplashSubPart.getFeatureByBacksplashType(type);
      // console.log("featureToClick2", featureToClick);
    }
    console.log("featureToClick", featureToClick);
    if (featureToClick) {
      featureToClick.handleClick();
      this.props.setActiveFeature(featureToClick);
      // this.props.toggleShowDescriptionCover(false);
      this.forceUpdate();
      if (this.props.updateParent) {
        this.props.updateParent(featureToClick);
      }
      this.props.updateCanvasCount();
    }
    if (this.props.useButtons) {
      this.props.setLookActiveFeature(featureToClick);
    }
  };

  getBacksplashPart = () => {
    const layout = getCurrentLayout();
    const wallsParent = layout.parts["Walls"];
    return wallsParent.relatedItems.find(relItem => relItem.partId === "backsplash");
  };

  getValueText = () => {
    if (this.props.bvOpened) { // visualizer
      return <FormattedMessage id={
        (this.props.windowWidth < 1280) ? "quotingTool.backsplashSelectLabelSmallScreens" : "quotingTool.backsplashSelectLabelMediumScreens"
      }/>
    } else {
      if (this.props.windowWidth < 1160) {
        return <FormattedMessage id="quotingTool.backsplashSelectLabelSmallScreens"/>
      } else if (this.props.windowWidth < 1600) {
        return <FormattedMessage id="quotingTool.backsplashSelectLabelMediumScreens"/>
      } else {
        return <FormattedMessage id="quotingTool.backsplashSelectLabelLargeScreens"/>
      }
    }
  };

  getBackplashTypes = () => {
    if (document.kvConfig.visualizerType === "Kitchen") {
      return BACKSPLASH_TYPES
    }
    if (this.props.fabricatorData.isEncore) {
      const backsplashSubPart = this.getBacksplashPart();
      if (backsplashSubPart) {
        return KVSCENE_BACKSPLASH_TYPES.filter(type => {
          return !!backsplashSubPart.getFeatureByBacksplashType(type, "", true)
        })
      }
    }
    return KVSCENE_BACKSPLASH_TYPES
  };

  renderButtons = (currentType) => {
    return (
      <WithClickCount>
        {(maxClickCountReached) => (
          <div className="lk-feature__options">
          <span className="lk-feature__options-title">
            <FormattedMessage id="quotingTool.backsplashSelectLabelMediumScreens"/>
          </span>
            <div className="lk-feature__options-list">
              {this.getBackplashTypes().map(backsplashType => {
                const isActive = currentType === backsplashType;
                return (
                  <Button className={"look-button look-button--half-radius look-button--option lk-type"
                    + (isActive ? " look-button--option-active" : "")}
                    // + (isActive ? " look-button--option-active" : "") + (disabled ? " look-button--disabled" : "")}
                          key={backsplashType}
                          // disabled={disabled}
                          onClick={() => this.handleBacksplashItemClick(backsplashType, maxClickCountReached)}>
                    {/*<FormattedMessage id={"grohe.feature.placement." + backsplashType}/>*/}
                    {backsplashType}
                  </Button>
                )
              })}
            </div>
          </div>
        )}
      </WithClickCount>
    )
  };

  render() {
    const backsplashSubPart = this.getBacksplashPart();
    const currentType = backsplashSubPart.getCurrentActiveFeatureType();
    if (this.props.useButtons) {
      return this.renderButtons(currentType)
    }
    // console.log("backsplashSubPart", );
    return (
      <UiSelect type={1}
                value={currentType}
                itemClick={this.handleBacksplashItemClick}
                selectItems={this.getBackplashTypes()}
                className={"backsplash-select"}
                valueText={this.getValueText()}
      />
    )
  }
}


const mapStateToProps = (store, ownProps) => {
  const {lookActiveFeature} = store.lookState;
  const fabricatorData = store.fabricatorState;
  const {canvasCount} = store.bathroomVisualizerState;
  return {
    bvOpened: store.bathroomVisualizerState.bvOpened,
    windowWidth: store.serverState.windowWidth,
    lookActiveFeature: ownProps.activeFeature || lookActiveFeature, // update active button
    fabricatorData, // update active button
    canvasCount,
  };
};

const mapDispatchToProps = {
  toggleSelectionFeatureInfo,
  setActiveFeature,
  toggleShowDescriptionCover,
  updateCanvasCount,
  setLookActiveFeature,
}

export default connect(mapStateToProps, mapDispatchToProps)(BacksplashSelect)
